import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "grid gap-x-6 gap-y-2 px-6 py-5 sm:grid-cols-3" }
const _hoisted_2 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_3 = {
  key: 0,
  class: "mt-0.5 text-sm text-gray-500"
}
const _hoisted_4 = { class: "min-w-0 sm:col-span-2" }


export default {
  __name: 'SettingRow',
  props: {
  label: { type: String, required: true },
  hint: { type: String, default: '' }
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(props.label), 1),
      (props.hint)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.hint), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

}